<template>
  <div class="model-apply-container">
    <CardBoxComponent :title="titleArea.name" :titleIcon="titleArea.titleIcon" :isBigSize="true">
      <div class="container-area">
        <div class="table-list-container">
          <Table border :columns="columns" :data="currentTableData">            
            <template slot-scope="{ row }" slot="applyStatus" >
              <Tag :color="statusColor[row.applyStatus]">{{ row.applyStatusValue }}</Tag>
            </template>
            <template slot-scope="{ row }" slot="filePath" >
              <Button v-if="row.filePath" shape="circle" icon="md-download" :to="row.filePath">附件下载</Button>
            </template>
            <template slot-scope="{ row }" slot="action" >
              <a v-if="row.applyStatus === 1" @click="showApply(row)">编辑</a>
            </template>
          </Table>
        </div>
        <PagerComponent :currentPager="pageNum" :totalCount="totalCount" :currentUnit="pageSize" :listOfBars="[10, 15, 20]"  @on-getCurrentPager="getCurrentPager" @on-changeUnit="getPagerSize"></PagerComponent>
      </div>
    </CardBoxComponent>

    <!-- 制作同款 - 弹窗 -->
    <ModelMakeSame v-model="applyData.isShow" :detail="applyData.data" @refresh="searchAction" />
  </div>
</template>

<script>
import CardBoxComponent from '@/components/CardBoxComponent'
import TableRowUnitComponent from "@/components/TableRowUnitComponent"
import PagerComponent from "@/components/PagerComponent"
import ModelPreview from "@/components/new/model/model_item/ModelPreview"
import { handleLocalStorage } from '@/utils/handleLocalStorage.js'
import ModelMakeSame from "@/components/new/model/model_item/ModelMakeSame" // 制作同款

export default {
  name: 'OperationIndex',
  components: { CardBoxComponent, TableRowUnitComponent, PagerComponent, ModelPreview, ModelMakeSame },
  data() {
    return {
      titleArea: {
        name: '我的需求',
        titleIcon: require('@/assets/img/icon/page-icon-operation.png')
      },
      columns: [
        {
          title: '商机编号',
          key: 'id'
        },
        {
          title: '客户姓名',
          key: 'userName'
        },
        {
          title: '客户手机号',
          key: 'phone'
        },
        {
          title: '客户公司',
          key: 'company'
        },
        {
          title: '公司地址',
          key: 'city'
        },
        {
          title: '需求简述',
          key: 'description'
        },
        {
          title: '提出时间',
          key: 'createTime'
        },
        {
          title: '需求附件',
          slot: 'filePath'
        },
        {
          title: '状态',
          slot: 'applyStatus'
        },
        {
          title: '操作',
          slot: 'action'
        }
      ],
      statusColor: {
        1: 'primary', // 未接单
        2: 'warning', // 制作中
        3: 'success', // 已派单
        4: 'default' // 已结单
      },
      currentTableData: [],
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      connectData: {
        isShow: false,
        modelId: ''
      },
      previewData: {
        isShow: false,
        modelId: ''
      },
      applyData: {
        isShow: false,
        data: {}
      }
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    // 获取需求详情
    showApply(data) {
      this.applyData.isShow = true
      this.applyData.data = data
    },
    searchAction() {
      this.pageNum = 1
      this.getTableData()
    },
    // 预览
    previewModel(modelId) {
      this.previewData.isShow = true
      this.previewData.modelId = modelId
    },
    // 获取记录列表
    getTableData() {
      this.$http('/api/modelApply/page', {
        userId: handleLocalStorage.getSomeItem("userInfo").userId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        if(res.data.status !== 200) {
          return this.$Message.error(res.data.msg)
        }
        this.currentTableData = res.data.data.list
        this.totalCount = res.data.data.total
      })
    },
    //获取单条记录
    getModelApply(){
      this.$http('/api//getModelApply/').then(res => {
        if(res.data.status !== 200) {
          return this.$Message.error(res.data.msg)
        }
        this.currentTableData = res.data.data.list
        this.totalCount = res.data.data.total
      })
    },
    // 切换页面
    getCurrentPager(index) {
      this.pageNum = index
      this.getTableData()
    },
    // 切换每页显示条数
    getPagerSize(size, page) {
      this.pageSize = size
      this.pageNum = page
      this.getTableData()
    }
  }
}
</script>

<style scoped>
.model-apply-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.container-area {
  display: flex;
  flex-direction: column;
  height: calc(100% - 107px);
  min-height: 720px;
  margin: 30px 40px auto 40px;
  overflow: auto;
  overflow-y: hidden;
}
.table-list-container {
  height: calc(100% - 86px);
  margin-bottom: 40px;
}
/* table样式 */
.table-list-container >>> .ivu-table-wrapper {
  height: 100%;
  font-family: FZLTHJW--GB1-0;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.table-list-container >>> .ivu-table-body {
  height: calc(100% - 40px);
  min-height: 589px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
